import { Loading } from 'components'
import { useBackendChallenge } from 'features/Backend'
import { useRouter } from 'next/router'
import { NextSeo } from 'next-seo'
import React from 'react'

import BackendChallengesContext from '../BackendChallenges.context'
import { getBackendChallenge } from '../utils/getBackendChallenge'

const BackendChallenge = () => {
  const router = useRouter()
  const { slug, question_id } = router.query
  const challenge_slug = typeof slug === 'string' ? slug : ''
  const challenge_id = typeof question_id === 'string' ? question_id : ''

  const { data: backendChallengeDetails, isLoading } =
    useBackendChallenge(challenge_id)

  if (isLoading) return <Loading centerParent />

  if (!backendChallengeDetails) return <p>Challenge Not Found!!</p>

  if (backendChallengeDetails.slug !== challenge_slug)
    return <p>Wrong Challenge!!</p>

  const BackendChallengeComponent = getBackendChallenge(
    backendChallengeDetails.challenge_type
  )

  return (
    <BackendChallengesContext.Provider
      value={{ question: backendChallengeDetails }}>
      <NextSeo
        title={backendChallengeDetails.name}
        canonical={`https://devsnest.in/backend-challenges/${challenge_slug}/${backendChallengeDetails.id}`}
      />
      <BackendChallengeComponent />
    </BackendChallengesContext.Provider>
  )
}

BackendChallenge.layout = {
  pageClassName: 'max-w-full scroll-hide',
  screenHeight: true,
  hideFooter: true,
  haveMaxWidth: false,
  navProps: {
    fullWidth: true
  }
}

BackendChallenge.seo = {
  description:
    'Solve challenging Backend questions that have been asked by top tech companies to improve your coding abilities and get ready for interviews.'
}

export default BackendChallenge
